import { Template } from "@suse-o11y/template";
import { z } from "zod";

const schema = z
	.object({
		text: z
			.string()
			.trim()
			.catch("")
			.transform((text) => Template<null>(text))
			.optional(),
	})
	.catch({});

type Markdown = z.infer<typeof schema>;

const Markdown = { schema };

export { Markdown };
